export const validObject = (obj: any): obj is Record<string, any> => typeof obj === "object" && obj !== null;
export const getObject = <O extends object>(obj: O, def?: O): Partial<O> => validObject(obj) ? obj : (validObject(def) ? def : {});

/**
 * Parse a string into an object, without throwing an error if the string is not a valid JSON
 * @param str The string to parse
 * @returns The parsed object, or undefined if the string is not a valid JSON
 */
export const parse_no_try_catch = (str: string) => {
    try {
        if (typeof str !== "string" || str.length === 0) return;
        else return JSON.parse(str);
    }
    catch (error) {
        return;
    }
}